angular.module('dpw.components')
    .directive('dpwDropDownList', [ function () {
        return {
            restrict: 'A',
            scope: {
                optionsSource: '=',
                model: '=',
                name: '@',
                itemType: '@',
                labelPattern: '@',
                optionPattern: '@',
                labelRight: '=',
                isDisabled: '@'

            },
            controller: ['$scope', function ($scope) {
                if (angular.isArray($scope.optionsSource) && ($scope.optionsSource.length > 0)) {
                    ($scope.model == null) && ($scope.model = ($scope.itemType == 'object' ? $scope.optionsSource[0].id : $scope.optionsSource[0]));
                }
                if ($scope.itemType == 'object') {
                    $scope.labelPattern = $scope.labelPattern || '(optionsSource|filter:{id: model}:true)[0].text';
                    $scope.optionPattern = $scope.optionPattern || 'item.id as item.text for item in optionsSource';
                } else {
                    $scope.labelPattern = $scope.labelPattern || 'model';
                    $scope.optionPattern = $scope.optionPattern || 'item as item for item in optionsSource';
                }
            }],
            templateUrl: 'dpw-drop-down-list.html'
        };
    }]);